import {icons} from 'lucide-react';

export function isValidLucideIconComponent(value: string): value is keyof typeof icons {
  return value in icons;
}
